import { registerSharedDependency } from 'core-components/helpers/MFHelper'
import { INotificationTemplate, NotificationTemplate } from 'core-components/library/popup'
import { Notification } from 'core-components/library/popup/notification/Notification'

import { NOTIFICATION_AUTOHIDE_DURATION } from './constants'
import { useNotificationsQueue } from './hooks/useNotificationsQueue'
import { IExtendedNotificationPopup } from './models/IExtendedNotificationPopup'

interface IShowSimple {
  message: string
}

class NotificationControllerClass {
  private showMethod: (props: IExtendedNotificationPopup) => string = () => {
    console.error('You must add NotificationContainer from core-component/popup in page wrapper')
    return ''
  }
  private closeMethod: (id: string) => void = () => undefined
  show(props: IExtendedNotificationPopup): string {
    return this.showMethod(props)
  }

  close(id: string) {
    return this.closeMethod(id)
  }

  showSuccess({ message }: IShowSimple) {
    this.baseShow(message, 'success')
  }

  showWarning({ message }: IShowSimple) {
    this.baseShow(message, 'warning')
  }

  showError({ message }: IShowSimple) {
    this.baseShow(message, 'danger')
  }

  private baseShow(message: string, type: INotificationTemplate['type']) {
    this.show({
      autoHideDuration: NOTIFICATION_AUTOHIDE_DURATION,
      content: (contentData) => (
        <NotificationTemplate
          closePopup={contentData.close}
          content={message}
          type={type}
          closeButtonVisible={true}
        />
      ),
    })
  }
}

export const NotificationController = registerSharedDependency<NotificationControllerClass>(
  'NotificationController',
  () => new NotificationControllerClass()
)

export const NotificationContainer = () => {
  const { notifications, showNotification, closeNotification } = useNotificationsQueue()

  // @ts-ignore TO REDUX
  NotificationController.showMethod = showNotification
  // @ts-ignore TO REDUX
  NotificationController.closeMethod = closeNotification
  return (
    <>
      {notifications.map((notificationProps) => {
        return (
          <Notification
            key={notificationProps.id}
            {...notificationProps}
            onClose={() => {
              if (notificationProps.id) {
                closeNotification(notificationProps.id)
              }
            }}
          />
        )
      })}
    </>
  )
}
